import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Message from '@/utils/globalFeedback'
import { getToken } from '@/utils/auth'
import { authErrorMessage, getLandingPath, isChunkLoadError, recoverChunkLoad } from '@/utils/authFlow'

const whiteList = ['/login', '/external/approval']
let recoveringToLogin = false

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const token = getToken()
  if (!token) {
    if (store.getters.token || store.getters.roles.length) await store.dispatch('FedLogOut')
    if (whiteList.indexOf(to.path) !== -1) next()
    else next({ path: '/login', replace: true })
    NProgress.done()
    return
  }

  // 初始化失败后保留登录页的重试入口，不在 /login 和首页之间循环跳转。
  if (to.path === '/login' && store.state.permission.initializationError) {
    next()
    return
  }

  const version = store.state.user.sessionVersion
  const needsRoutes = store.state.permission.routesToken !== token
  try {
    const routes = await store.dispatch('InitializeUserRoutes')
    if (token !== getToken() || version !== store.state.user.sessionVersion) {
      next(false)
      NProgress.done()
      return
    }
    if (to.path === '/login' || to.path === '/') {
      next({ path: getLandingPath(routes), replace: true })
    } else if (needsRoutes) {
      next({ ...to, path: to.path.replace(/\/+/g, '/'), replace: true })
    } else {
      next()
    }
  } catch (error) {
    if (token !== getToken() || version !== store.state.user.sessionVersion || error.code === 'SESSION_CHANGED') {
      next(false)
    } else {
      if (error.code === 401 || error.code === 'AUTH_INFO_INVALID') await store.dispatch('FedLogOut')
      store.commit('SET_ROUTE_ERROR', authErrorMessage(error))
      if (to.path === '/login') next()
      else next({ path: '/login', replace: true })
    }
    NProgress.done()
  }
})

router.onError(error => {
  NProgress.done()
  const current = router.currentRoute
  const atEntry = current.path === '/login' || !current.matched.length
  if (recoverChunkLoad(error, atEntry, typeof window === 'undefined' ? null : window)) return
  if (isChunkLoadError(error)) {
    store.commit('SET_ROUTE_ERROR', authErrorMessage(error))
    if (!current.matched.length && !recoveringToLogin) {
      recoveringToLogin = true
      router.replace('/login').catch(() => {}).then(() => { recoveringToLogin = false })
    } else if (current.path !== '/login') {
      Message.error('页面暂时未能加载，请保存当前内容后刷新重试。')
    }
  } else {
    Message.error(authErrorMessage(error))
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js